<template>
  <div
    class="h-100"
    :class="[jel_getClassObject(content), isMenuGaucheOuvert ? 'menu-ouvert' : 'menu-ferme']"
  >
    <div class="border-right h-100 d-flex flex-column">
      <button class="menu-bouton py-2" @click="ouvrirFermerTiroir()">
        <b-icon icon="list"></b-icon>
        <span class="sr-only">
          {{
            isMenuGaucheOuvert
              ? $i18n.tc('messageComponent.actionMenu', 2)
              : $i18n.tc('messageComponent.actionMenu', 1)
          }}
          {{ $t('messageComponent.burgerMenu') }}
        </span>
      </button>
      <Menu :content="content">
        <template #element="{ itemElement }">
          <div class="item" :class="{ 'menu-titre': itemElement.image }">
            <div class="img-container d-flex align-items-center justify-content-center">
              <b-img-lazy
                v-if="itemElement.image"
                class="img-item"
                :src="jel_getFichierSrc(itemElement.image)"
                :alt="isMenuGaucheOuvert ? '' : itemElement.item"
              />
            </div>
            <div>
              {{ itemElement.item }}
            </div>
          </div>
        </template>
      </Menu>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Menu from '@/components/base/Menu';
import session from '@/services/api/compte/session';
import { bus } from '@/main';

export default {
  name: 'MenuGauche',
  // eslint-disable-next-line vue/no-reserved-component-names
  components: { Menu },
  props: { content: { type: Object, required: true } },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          actionMenu: 'Ouvrir | Fermer',
          burgerMenu: 'le menu de navigation',
        },
      },
      en: {
        messageComponent: {
          actionMenu: 'Open | Close',
          burgerMenu: 'the navigation menu',
        },
      },
    },
  },
  data() {
    return { tiroirOuvert: true };
  },
  computed: {
    ...mapGetters({
      getIsMenuGaucheOuvert: 'menu/getIsMenuGaucheOuvert',
    }),
    isMenuGaucheOuvert() {
      if (this.getIsMenuGaucheOuvert !== null) {
        return this.getIsMenuGaucheOuvert;
      }
      const toggleMenuGauche = sessionStorage.getItem('toggleMenuGaucheOuvert');
      if (toggleMenuGauche != null) {
        const statutToggleMenuGauche = toggleMenuGauche == 'true';
        if (this.getIsMenuGaucheOuvert != statutToggleMenuGauche) {
          this.setIsMenuGaucheOuvert(statutToggleMenuGauche);
        }
        return statutToggleMenuGauche;
      }
      return this.$mq == 'xl' || this.$mq == 'xxl';
    },

    listeItems() {
      const itemsFiltre = [];
      this.content.listeItems['@nodes'].forEach((item) => {
        itemsFiltre.push(this.content.listeItems[item]);
      });
      return itemsFiltre;
    },
  },
  mounted() {
    bus.$emit('changeWidth');
    this.initSectionsMenu();
  },
  methods: {
    ...mapActions({
      toggleMenuGauche: 'menu/toggleMenuGauche',
      addSectionMenu: 'menu/addSectionMenu',
      setIsMenuGaucheOuvert: 'menu/setIsMenuGaucheOuvert',
    }),
    sessionEstOuverte() {
      return session.sessionEstOuverte();
    },
    initSectionsMenu() {
      this.listeItems.forEach((item) => {
        if (item.image) {
          this.addSectionMenu(item);
        }
      });
    },
    ouvrirFermerTiroir() {
      this.toggleMenuGauche();
      this.$nextTick(() => {
        bus.$emit('changeWidth');
      });
    },
    toggleMenuGauche() {
      let statutMenuGauche = null;
      const toggleMenuGauche = sessionStorage.getItem('toggleMenuGaucheOuvert');
      if (toggleMenuGauche != null) {
        statutMenuGauche = toggleMenuGauche == 'true';
      } else {
        statutMenuGauche = this.getIsMenuGaucheOuvert ?? (this.$mq == 'xl' || this.$mq == 'xxl');
      }
      this.setIsMenuGaucheOuvert(!statutMenuGauche);
      sessionStorage.setItem('toggleMenuGaucheOuvert', !statutMenuGauche);
    },
  },
};
</script>

<style lang="scss" scoped>
div.menu-ouvert {
  width: 240px;
  .menu-bouton {
    padding: 1rem;
  }
}
div.menu-ferme {
  width: fit-content;
  max-width: 55px;
  .menu-bouton {
    width: 100%;
    display: flex;
    justify-content: center;
    align-self: center;
  }
  ::v-deep {
    .menu-ouvert {
      display: none;
    }
    div.list-group {
      .list-group-item {
        .item {
          display: none;
          padding: 0.5rem 0 0;
          &.menu-titre {
            display: flex;
            flex-direction: column;
            width: -webkit-fill-available;
            text-align: center;
            > div {
              font-size: 0.575rem;
              font-family: graphik_regular;
              display: block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              padding: 0 0.25rem;
            }
          }
        }
      }
    }
  }
}
.menu-bouton {
  background-color: transparent;
  border: none;
  text-align: left;
  svg {
    color: #152665;
    font-size: 1.5rem;
  }
  &:focus-visible {
    outline: none;
    background-color: $bleu-pale-casino;
  }
}

div::v-deep div.list-group {
  padding-bottom: 1rem;
  .list-group-item {
    text-decoration: none;
    color: $noir-casino;
    display: block;
    font-size: 0.9rem;
    line-height: 1.125rem;
    font-family: graphik_regular;
    padding: 0;
    .item {
      display: flex;
      padding: 0.625rem 0;
    }
    &:hover,
    &.router-link-exact-active {
      background-color: $blanc-casino;
    }
    &:focus-visible {
      outline: none;
      background-color: $bleu-pale-casino;
    }
    .menu-titre {
      font-family: graphik_semibold;
    }
    svg {
      color: $couleur-primaire-bouton-theme-clair;
      font-size: 1.25rem;
    }
  }

  .img-item {
    height: 20px;
    max-width: 32px;
  }
  .img-container {
    width: 56px;
  }
}
</style>
